import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PrerenderReady from '../PrerenderReady';
import { useLang } from '../../contexts/LangContext';
import PublicToggleBar from '../PublicToggleBar';

// Przykladowy raport Gap Audit (11.08) - decyzja Marcina: fikcyjna firma-przyklad zamiast
// realnego rekordu z bazy (zero ryzyka danych, nigdy nie wygasa, dziala bez logowania i bez
// tokenu). Ten sam wzorzec izolacji .galp co CennikPage.jsx/BlogPage.jsx. Wizualnie nawiazuje do
// gap-mvp/PublicReportView.jsx (prawdziwy widok raportu po zalogowaniu), ale to OSOBNY,
// samodzielny komponent - PublicReportView korzysta z innego, nieizolowanego zestawu klas
// (ga-root/card/kpi), ktorego ta publiczna strona marketingowa celowo nie ladowuje.

const FONT_FACES = `
@font-face{font-family:'Oswald';src:url('/fonts/oswald-400-latin-ext.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-400-latin.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-500-latin-ext.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-500-latin.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-600-latin-ext.woff2') format('woff2');font-weight:600;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Oswald';src:url('/fonts/oswald-600-latin.woff2') format('woff2');font-weight:600;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-400-latin-ext.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-400-latin.woff2') format('woff2');font-weight:400;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-500-latin-ext.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;}
@font-face{font-family:'Roboto Mono';src:url('/fonts/robotomono-500-latin.woff2') format('woff2');font-weight:500;font-style:normal;font-display:swap;unicode-range:U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;}
`;

const PAGE_CSS = `
.galp{
  --paper:#E7E8E3; --paper-raised:#F8F9F6; --panel2:#DEE1DA; --ink:#1B2124; --ink-soft:#5C6569;
  --line:#C6CAC2; --line-soft:#D9DCD5;
  --accent:#1E7A46; --accent-ink:#FFFFFF; --accent-soft:#DCEEE2;
  --amber:#9C6A16; --amber-soft:#F3E4C8;
  --red:#B93A2C; --red-soft:#F3DCD4;
  --shadow:0 1px 2px rgba(20,30,25,.05), 0 8px 20px -12px rgba(20,30,25,.14);
  background:var(--paper); color:var(--ink); font-family:'Oswald',system-ui,sans-serif; font-weight:500; font-size:16px; line-height:1.6; -webkit-font-smoothing:antialiased;
}
/* Ciemny motyw (11.08) - patrz CennikPage.jsx dla pelnego kontekstu tego bloku (izolacja
   per-strona swiadoma, data-theme siedzi na <html>). @media print{} nizej MUSI wygrac nad tym
   blokiem (wymuszony jasny wydruk niezaleznie od motywu ekranu) - kolejnosc w tym pliku to
   zapewnia, print jest zdefiniowany PO tym bloku. */
[data-theme='dark'] .galp{
  --paper:#15181A; --paper-raised:#1E2225; --panel2:#262B27; --ink:#E9EAE4; --ink-soft:#8B948F;
  --line:#33383A; --line-soft:#282C2E;
  --accent:#3CB878; --accent-ink:#0B1712; --accent-soft:#1B2E22;
  --amber:#D79A3C; --amber-soft:#332A18;
  --red:#E2604C; --red-soft:#3A211D;
  --shadow:0 1px 2px rgba(0,0,0,.4), 0 10px 24px -12px rgba(0,0,0,.55);
}
.galp *{box-sizing:border-box;}
.galp h1,.galp h2,.galp h3{margin:0; font-weight:600; text-transform:uppercase; letter-spacing:.02em; text-wrap:balance; color:var(--ink);}
.galp p{margin:0 0 1em; max-width:65ch; color:var(--ink-soft);}
.galp p:last-child{margin-bottom:0;}
.galp a{color:var(--accent); text-decoration:none;}
.galp .wrap{max-width:820px; margin:0 auto; padding:0 24px;}
.galp .eyebrow{font-family:'Roboto Mono',monospace; font-size:.72rem; font-weight:500; text-transform:uppercase; letter-spacing:.18em; color:var(--accent); display:inline-flex; align-items:center; gap:9px; margin-bottom:14px;}
.galp .eyebrow::before{content:''; width:6px; height:6px; border-radius:50%; background:var(--accent);}

.galp .topbar{display:flex; align-items:center; justify-content:space-between; gap:20px; padding:16px 0; border-bottom:1px solid var(--line);}
.galp .brand{display:flex; align-items:center; gap:10px; font-weight:700; font-size:.95rem; text-transform:uppercase; letter-spacing:.05em;}
.galp .brand .sq{width:17px; height:17px; background:var(--accent); border-radius:3px;}
.galp .brand small{font-weight:500; color:var(--ink-soft); letter-spacing:.1em; font-size:.68rem;}
.galp .navlinks{display:flex; align-items:center; gap:22px; margin-right:auto; margin-left:32px;}
.galp .navlinks a{font-size:.82rem; font-weight:600; color:var(--ink-soft); text-decoration:none; text-transform:uppercase; letter-spacing:.04em;}
.galp .navlinks a:hover{color:var(--accent);}
.galp .toggles{flex:none;}
.galp .hamburger{display:none; background:none; border:none; cursor:pointer; padding:8px; flex:none;}
.galp .hamburger span{display:block; width:22px; height:2px; background:var(--ink); margin:5px 0;}
.galp .mobile-menu{display:none; flex-direction:column; padding:6px 0 14px; border-bottom:1px solid var(--line);}
.galp .mobile-menu.open{display:flex;}
.galp .mobile-menu a.mlink{padding:13px 4px; font-size:.9rem; font-weight:600; color:var(--ink); text-decoration:none; text-transform:uppercase; letter-spacing:.03em; border-bottom:1px solid var(--line-soft);}
.galp .mobile-menu .btn{margin-top:12px; justify-content:center;}
.galp .mobile-menu .toggles{margin-top:12px; justify-content:center; display:flex;}
/* !important konieczny (11.08, patrz CennikPage.jsx) - PublicToggleBar ustawia display:flex jako
   inline style, ktory zawsze wygrywa z reguzy arkusza zewnetrznego bez wzgledu na specyficznosc. */
@media (max-width:600px){ .galp .navlinks{display:none;} .galp .topbar .toggles{display:none !important;} .galp .hamburger{display:block;} }
@media print{ .galp .hamburger{display:none !important;} .galp .mobile-menu{display:none !important;} .galp .toggles{display:none !important;} }

.galp .btn{font-family:'Oswald',sans-serif; font-size:.82rem; font-weight:600; text-transform:uppercase; letter-spacing:.05em; padding:11px 22px; border-radius:5px; border:1px solid var(--line); color:var(--ink); background:var(--paper-raised); display:inline-flex; align-items:center; gap:8px; cursor:pointer; transition:border-color .15s; text-decoration:none;}
.galp .btn:hover{border-color:var(--ink-soft);}
.galp .btn.pri{background:var(--accent); color:var(--accent-ink); border-color:var(--accent); box-shadow:var(--shadow);}

.galp .rephead{padding:48px 0 28px;}
.galp .rephead h1{font-size:clamp(1.5rem,3.4vw,2rem); margin:0 0 10px;}
.galp .rep-badge{display:inline-flex; align-items:center; gap:8px; background:var(--amber-soft); color:var(--amber); font-family:'Roboto Mono',monospace; font-size:.7rem; font-weight:600; text-transform:uppercase; letter-spacing:.06em; padding:6px 12px; border-radius:100px; margin-bottom:16px;}
.galp .rep-actions{display:flex; gap:10px; margin-top:20px; flex-wrap:wrap;}

.galp .repcard{background:var(--paper-raised); border:1px solid var(--line); border-radius:13px; padding:26px; margin-bottom:16px;}
.galp .repmeta{font-family:'Roboto Mono',monospace; font-size:.8rem; color:var(--ink-soft); margin-bottom:18px;}
.galp .repkpis{display:grid; grid-template-columns:1fr 1fr; gap:14px;}
.galp .repkpi{background:var(--panel2); border-radius:9px; padding:16px 18px;}
.galp .repkpi .kl{font-size:.68rem; text-transform:uppercase; letter-spacing:.07em; color:var(--ink-soft); margin-bottom:6px; font-weight:600;}
.galp .repkpi .kv{font-family:'Roboto Mono',monospace; font-size:1.7rem; font-weight:600; color:var(--ink);}
.galp .repkpi .kv small{font-size:1rem; color:var(--ink-soft);}
@media (max-width:520px){ .galp .repkpis{grid-template-columns:1fr;} }

.galp .finding{border-top:1px solid var(--line); padding:16px 0;}
.galp .finding:first-child{border-top:none; padding-top:4px;}
.galp .finding-top{display:flex; align-items:center; gap:10px; margin-bottom:8px; flex-wrap:wrap;}
.galp .fpill{display:inline-flex; align-items:center; gap:6px; font-family:'Roboto Mono',monospace; font-size:.68rem; font-weight:600; text-transform:uppercase; letter-spacing:.05em; padding:4px 10px; border-radius:100px;}
.galp .fpill .d{width:6px; height:6px; border-radius:50%;}
.galp .fpill.crit{background:var(--red-soft); color:var(--red);}
.galp .fpill.crit .d{background:var(--red);}
.galp .fpill.med{background:var(--amber-soft); color:var(--amber);}
.galp .fpill.med .d{background:var(--amber);}
.galp .fpill.low{background:var(--accent-soft); color:var(--accent);}
.galp .fpill.low .d{background:var(--accent);}
.galp .fclause{font-family:'Roboto Mono',monospace; font-size:.74rem; color:var(--ink-soft);}
.galp .ftext{font-size:.92rem; color:var(--ink); margin-bottom:6px;}
.galp .fcite{font-size:.83rem; font-style:italic; color:var(--ink-soft); padding-left:12px; border-left:2px solid var(--line);}

.galp .disclaimer{font-size:.78rem; color:var(--ink-soft); text-align:center; margin-top:20px;}

.galp footer{border-top:1px solid var(--line); padding:24px 0 38px; display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; font-family:'Roboto Mono',monospace; font-size:.72rem; color:var(--ink-soft);}
.galp footer .legal{display:flex; gap:16px;}
.galp footer .legal a{color:var(--ink-soft); text-decoration:none;}
.galp footer .legal a:hover{color:var(--accent);}

@media print{
  .galp{background:#fff;}
  .galp .no-print{display:none !important;}
  .galp .topbar{border-bottom:1px solid #ccc;}
  .galp .repcard{box-shadow:none; border:1px solid #ccc;}
  .galp .rep-badge{display:none;}
}
`;

const FINDINGS = [
  {
    priority: 'crit', clause: '8.1',
    text: 'Brak udokumentowanej procedury cyklicznego przeglądu uprawnień dostępowych do systemów krytycznych.',
    cite: 'Dostęp do systemów przyznawany jest na wniosek przełożonego - polityka nie precyzuje, kto i jak często weryfikuje, czy uprawnienia są nadal zasadne.',
  },
  {
    priority: 'med', clause: '6.1.2',
    text: 'Rejestr ryzyk nie zawiera oceny wpływu dla 3 z 12 zidentyfikowanych aktywów informacyjnych.',
    cite: 'Ocena ryzyka prowadzona jest dla głównych systemów - brak wzmianki o kryterium doboru "głównych" systemów ani harmonogramu uzupełnienia pozostałych.',
  },
  {
    priority: 'med', clause: '9.1',
    text: 'Dokument nie definiuje częstotliwości przeglądu logów systemowych ani osoby za to odpowiedzialnej.',
    cite: 'Logi są monitorowane na bieżąco - stwierdzenie bez wskazanego właściciela procesu ani mierzalnego interwału kontroli.',
  },
  {
    priority: 'low', clause: '5.1',
    text: 'Brak daty ostatniej rewizji oraz numeru wersji na stronie tytułowej polityki.',
    cite: null,
  },
];

const PRIORITY_LABEL = { crit: 'Krytyczne', med: 'Średnie', low: 'Kosmetyczne' };

// EN mirror (11.08) - ten sam wzorzec co SECTIONS/SECTIONS_EN w TermsPage.jsx.
const FINDINGS_EN = [
  {
    priority: 'crit', clause: '8.1',
    text: 'No documented procedure for periodic review of access permissions to critical systems.',
    cite: "Access to systems is granted upon a supervisor's request - the policy does not specify who verifies whether permissions are still justified, or how often.",
  },
  {
    priority: 'med', clause: '6.1.2',
    text: 'The risk register does not include an impact assessment for 3 of the 12 identified information assets.',
    cite: "Risk assessment is carried out for the main systems - no mention of the criteria used to select 'main' systems, or a timeline for covering the rest.",
  },
  {
    priority: 'med', clause: '9.1',
    text: 'The document does not define how often system logs are reviewed or who is responsible for it.',
    cite: 'Logs are monitored on an ongoing basis - a statement with no assigned process owner or measurable review interval.',
  },
  {
    priority: 'low', clause: '5.1',
    text: "No last-revision date or version number on the policy's title page.",
    cite: null,
  },
];

const PRIORITY_LABEL_EN = { crit: 'Critical', med: 'Medium', low: 'Cosmetic' };

export default function SampleReportPage() {
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const { lang } = useLang();
  const e = lang === 'en';
  const findings = e ? FINDINGS_EN : FINDINGS;
  const priorityLabel = e ? PRIORITY_LABEL_EN : PRIORITY_LABEL;
  const goTrial = (ev) => { ev.preventDefault(); navigate('/app?tab=register'); };
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="galp" ref={rootRef}>
      <style>{FONT_FACES}</style>
      <style>{PAGE_CSS}</style>
      <Helmet>
        <title>{e ? 'Sample Gap Audit Report | Gap Assessment by MQS' : 'Przykładowy raport Gap Audit | Gap Assessment by MQS'}</title>
        <meta name="description" content={e
          ? 'See what a real Gap Audit result looks like: compliance score, prioritized findings with document citations, no registration required.'
          : 'Zobacz jak wygląda prawdziwy wynik analizy Gap Audit: wynik zgodności, priorytetowane ustalenia z cytatami z dokumentu, bez rejestracji.'} />
      </Helmet>
      <header className="wrap no-print">
        <div className="topbar">
          <a className="brand" onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/" style={{ textDecoration: 'none', color: 'inherit' }}><span className="sq"></span>Gap Assessment <small>by MQS</small></a>
          <nav className="navlinks">
            <a onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
            <a onClick={(ev) => { ev.preventDefault(); navigate('/cennik'); }} href="/cennik">{e ? 'Pricing' : 'Cennik'}</a>
          </nav>
          <PublicToggleBar style={{ marginLeft: 'auto' }} className="toggles" />
          <a className="btn pri" onClick={goTrial} href="/app?tab=register">{e ? 'Create an account and try it' : 'Załóż konto i wypróbuj'}</a>
          <button type="button" className="hamburger" aria-label="Menu" aria-expanded={menuOpen} onClick={() => setMenuOpen(v => !v)}>
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
          <a className="mlink" onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/">{e ? 'Home' : 'Strona główna'}</a>
          <a className="mlink" onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
          <a className="mlink" onClick={(ev) => { ev.preventDefault(); navigate('/cennik'); }} href="/cennik">{e ? 'Pricing' : 'Cennik'}</a>
          <div className="toggles"><PublicToggleBar /></div>
          <a className="btn pri" onClick={goTrial} href="/app?tab=register">{e ? 'Create an account and try it' : 'Załóż konto i wypróbuj'}</a>
        </div>
      </header>

      <div className="wrap">
        <section className="rephead">
          <div className="eyebrow">{e ? 'Sample report' : 'Przykładowy raport'}</div>
          <span className="rep-badge">{e ? 'Fictional data - for demonstration purposes only' : 'Dane fikcyjne - wyłącznie do celów demonstracyjnych'}</span>
          <h1>{e ? 'This is what a Gap Audit result looks like' : 'Tak wygląda wynik analizy Gap Audit'}</h1>
          <p>{e
            ? 'A real, no-login report view from the platform - exactly what your client receives after an analysis. Below: an example for an information security policy against ISO/IEC 27001.'
            : 'Prawdziwy, nielogowany widok raportu z platformy - dokładnie to, co dostaje Twój klient po analizie. Poniżej: przykład dla polityki bezpieczeństwa informacji względem ISO/IEC 27001.'}</p>
          <div className="rep-actions no-print">
            <a className="btn pri" href="/api/public/sample-report-pdf" download="gap-assessment-przykladowy-raport.pdf">{e ? 'Download as PDF' : 'Pobierz jako PDF'}</a>
            <a className="btn" onClick={goTrial} href="/app?tab=register">{e ? 'Create one for your client' : 'Zrób taki dla swojego klienta'}</a>
          </div>
        </section>

        <div className="repcard">
          <h3 style={{ marginBottom: 6 }}>{e ? 'Sample Co.' : 'Przykładowa Sp. z o.o.'}</h3>
          <div className="repmeta">ISO/IEC 27001 &middot; {e ? 'Information Security Policy' : 'Polityka Bezpieczeństwa Informacji'} &middot; 11.08.2026</div>
          <div className="repkpis">
            <div className="repkpi"><div className="kl">{e ? 'Compliance score' : 'Wynik zgodności'}</div><div className="kv">81<small>%</small></div></div>
            <div className="repkpi"><div className="kl">Status</div><div className="kv" style={{ fontSize: '1.15rem' }}>{e ? 'In review' : 'W recenzji'}</div></div>
          </div>
        </div>

        <div className="repcard">
          <h4 style={{ marginBottom: 14 }}>{e ? `Findings (${findings.length})` : `Ustalenia (${findings.length})`}</h4>
          {findings.map((f, i) => (
            <div className="finding" key={i}>
              <div className="finding-top">
                <span className={`fpill ${f.priority}`}><span className="d"></span>{priorityLabel[f.priority]}</span>
                <span className="fclause">{e ? 'clause' : 'pkt'} {f.clause}</span>
              </div>
              <div className="ftext">{f.text}</div>
              {f.cite ? <div className="fcite">„{f.cite}"</div> : <div className="fcite" style={{ borderLeftColor: 'transparent' }}>{e ? 'no excerpt available in the document' : 'brak fragmentu w dokumencie'}</div>}
            </div>
          ))}
        </div>

        <p className="disclaimer">{e
          ? "This is an example based on fictional data. Real reports are generated from your client's documents and are only accessible to them and you via a secure, expiring link."
          : 'To jest przykład na fikcyjnych danych. Prawdziwe raporty generowane są na podstawie dokumentów Twojego klienta i dostępne wyłącznie jemu oraz Tobie przez bezpieczny, wygasający link.'}</p>
      </div>

      <footer className="wrap no-print">
        <span>Gap Assessment by MQS</span>
        <span>{e ? 'ISO compliance audits for consultants · 13 standards · white-label' : 'Audyt zgodności ISO dla konsultantów · 13 norm · white-label'}</span>
        <span className="legal">
          <a onClick={(ev) => { ev.preventDefault(); navigate('/'); }} href="/">{e ? 'Home' : 'Strona główna'}</a>
          <a onClick={(ev) => { ev.preventDefault(); navigate('/blog'); }} href="/blog">Blog</a>
          <a onClick={(ev) => { ev.preventDefault(); navigate('/cennik'); }} href="/cennik">{e ? 'Pricing' : 'Cennik'}</a>
        </span>
      </footer>
      <PrerenderReady />
    </div>
  );
}
